module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-3a9973ca!./packages/dof-modal/diablo.css
// module id = 457
// module chunks = 0 1